import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavbarTop from 'components/navbar/top/navbarTop';
import NavbarVertical from 'components/navbar/vertical/navbarVertical';
import Footer from 'components/footer/footer';
import { useAppContext } from 'providers/appProvider';
import classNames from 'classnames';
import AppUpdateModal from 'components/common/appUpdateModal';
import OnboardingTour from 'components/onboarding/OnboardingTour';
import Coachmark from 'components/onboarding/Coachmark';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const {
    config: { isFluid, navbarPosition }
  } = useAppContext();

  return (
    <div className={classNames('main-layout', isFluid ? 'container-fluid' : 'container')}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div className={classNames('main-layout__content content', { 'pb-0': isKanban })}>
        <NavbarTop />
        <AppUpdateModal />
        <OnboardingTour />
        <Coachmark />
        {/* <Outlet />  */}
       <Outlet key={location.pathname + location.search} />
        {!isKanban && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;